import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { IltNotificationSettingsPage } from "@/features/admin/ilt-notifications/IltNotificationSettingsPage";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";

export const Route = createFileRoute("/admin/notifications")({
  // The ILT notification schedules are hidden while the ilt flag is off (the API 404s them too).
  beforeLoad: async () => {
    const { ilt } = await fetchFeatureFlags();
    if (!ilt) throw redirect({ to: "/admin" });
  },
  component: NotificationsRoute,
});

/** The ILT notification schedules (LMS-146), for admins who can see courses; editable with Courses.Manage. */
function NotificationsRoute() {
  return (
    <ProtectedRoute requiredPermissions={["Courses.Read"]} requiredRoles={["Admin"]}>
      <AdminPageLayout mainClassName="bg-secondary_alt">
        <IltNotificationSettingsPage />
      </AdminPageLayout>
    </ProtectedRoute>
  );
}
